import { Helmet } from "react-helmet-async";
import { useEffect, useState, useCallback } from "react";
import {
  Stack,
  Container,
  Typography,
  Tabs,
  Tab,
  Box,
  Card,
} from "@mui/material";
import { get } from "src/utils/networkUtils";
import HeadToHeadPlayground from "src/components/versus/HeadToHeadPlayground";
import SeasonPlayground from "src/components/versus/SeasonPlayground";
import UserLineupCard from "src/components/versus/UserLineupCard";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
    </div>
  );
}
export default function VersusPlaygroundPage() {
  const [value, setValue] = useState(0);
  const [lineup, setLineup] = useState([]);
  const [dailyStreak, setDailyStreak] = useState(null);
  const [loading, setLoading] = useState(false);
  //const [defaultLineupsLoading, setDefaultLineupsLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(1);
  const [username, setUsername] = useState("");

  const handleUserDailyStreak = useCallback(() => {
    get(`/admin/versus/users/${selectedUser}/daily-streak`)
      .then(function (response) {
        setDailyStreak(response.dailyStreak || null);
        setUsername(response.user?.username || "");
      })
      .catch(function (error) {
        console.error("Error fetching user lineup:", error);
        setDailyStreak(null);
      });
  }, [selectedUser]);

  useEffect(() => {
    handleUserDailyStreak();
  }, [handleUserDailyStreak]);

  /*
  const handleDefaultLineups = () => {
    setDefaultLineupsLoading(true);
    post(`/admin/versus/create-default-lineups`)
      .then(function (response) {
        console.log("Default lineups created successfully:", response.data);
        setDefaultLineupsLoading(false);
        window.location.reload();
      })
      .catch(function (error) {
        console.error("Error creating default lineups:", error);
        setDefaultLineupsLoading(false);
      });
  };
  */ const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Helmet>
        <title> Versus Game Playground </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={1}
        >
          <Typography variant="h4" gutterBottom>
            Versus Game Playground
          </Typography>
          {/** <Button
            variant="contained"
            startIcon={<Iconify icon={defaultLineupsLoading ? "mdi:loading" : "eva:play-circle-outline"} />}
            onClick={() => handleDefaultLineups()}
            disabled={defaultLineupsLoading}>
            {defaultLineupsLoading ? 'Creating...' : 'Create Default Lineups'}
          </Button> */}
        </Stack>

        <UserLineupCard
          lineup={lineup}
          dailyStreak={dailyStreak}
          username={username}
          loading={loading}
          setLoading={setLoading}
          selectedUser={selectedUser}
          setLineup={setLineup}
          setSelectedUser={setSelectedUser}
        />
        {lineup && lineup.length > 0 && (
          <Card sx={{ p: 2 }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
              >
                <Tab label="Head To Head" {...a11yProps(0)} />
                <Tab label="Daily" {...a11yProps(1)} />
                <Tab label="Season" {...a11yProps(2)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <HeadToHeadPlayground
                userId={selectedUser}
                onUpdateStreak={handleUserDailyStreak}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <HeadToHeadPlayground
                userId={selectedUser}
                onUpdateStreak={handleUserDailyStreak}
                defaultGameMode={5}
              />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <SeasonPlayground
                userId={selectedUser}
                onUpdateStreak={handleUserDailyStreak}
              />
            </TabPanel>
          </Card>
        )}
      </Container>
    </>
  );
}
